export const taskValidationRules = (taskDetails) => {
  const errors = {};

  if (!taskDetails.name || taskDetails.name.trim() === "") errors.name = "Name is required";
  else if (taskDetails.name.length < 3) errors.name = "Name must be at least 3 characters";
  if (!taskDetails.quantity || isNaN(taskDetails.quantity) || taskDetails.quantity <= 0)
    errors.quantity = "Quantity must be greater than 0";
  if (!taskDetails.unitOfMeasure || taskDetails.unitOfMeasure.trim() === "") errors.unitOfMeasure = "Please select a unit";

  return errors;
};

export const taskProgressValidationRules = (taskProgressDetails) => {
  const errors = {};
  const integerRegex = /^[1-9]\d*$/;

  if (!taskProgressDetails.description || taskProgressDetails.description.trim() === "")
    errors.description = "Description is required";
  else if (taskProgressDetails.description.length < 5) errors.description = "Description must be at least 5 characters";
  if (!taskProgressDetails.quantity || isNaN(taskProgressDetails.quantity) || taskProgressDetails.quantity <= 0)
    errors.quantity = "Quantity must be greater than 0";
  else if (taskProgressDetails.quantity && !integerRegex.test(taskProgressDetails.quantity))
    errors.quantity = "Decimal values are not allowed";

  return errors;
};
